export default __webpack_public_path__ + "static/Vermogens-2f8f2fa0e331d7c39911a3f6a52db826.png";